import {decorate, observable, action} from "mobx"

export class LocStore {
  poiId = null
  setPoiId(poiId) {
    this.poiId = poiId
  }
}

decorate(LocStore, {
  poiId: observable,
  setPoiId: action,
})
